import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrincipalDasboardLibService {
  public mychartType: any = '';
  public dataType: any = '';
  public userAllData: any = '';
  public userMetadata: any = {userDetails:[],resourceDetails:[]};
  public resoureMetadata = new Array();
  public userDetailObject: any = {};
  public userlist:any = false;
  public myEndTime :any;
 
  //for change chart Type
  public chartType = new BehaviorSubject(this.mychartType);
  public chartType$ = this.chartType.asObservable();
  //for change userWise To classRoom wise or vice versa
  public isUserWise_data = new BehaviorSubject(true);
  public isUserWise_data$ = this.isUserWise_data.asObservable();
  // for all user and current user information
  public isAllUsers = new BehaviorSubject(this.userlist);
  public isAllUsers$ = this.isAllUsers.asObservable();
  //for get details of selected user
  public detailedviewData = new BehaviorSubject(this.userMetadata);
  public detailedviewData$ = this.detailedviewData.asObservable();


  constructor() {}

  genarateResourseReqiuredData(data: any): any {
    let resouseID: any;
    let title: any;
    let subject: any;
    let grade: any;
    let chapter: any;
    let teachingpoint: any;
    let type: any;
    let resourceMetadataMatrix = new Array();
    let resourceMetadata = data.getElementsByTagName('resourceMetadata');
    for (var i = 0; i < resourceMetadata.length;i++){
      //----------//resouseID
      resouseID = resourceMetadata[i].getAttribute('resourceId');
      //----------//subject
      if (resourceMetadata[i].getElementsByTagName('subject')[0] != undefined &&resourceMetadata[i].getElementsByTagName('subject')[0].hasChildNodes()) {
        if (resourceMetadata[i].getElementsByTagName('subject')[0].getElementsByTagName('title')[0] != undefined &&resourceMetadata[i].getElementsByTagName('subject')[0].getElementsByTagName('title')[0].hasChildNodes()) {
          subject = resourceMetadata[i].getElementsByTagName('subject')[0].getElementsByTagName('title')[0].firstChild.nodeValue;
        } else {
          subject = '';
        }
      } else {
        subject = '';
      }
      //----------//grade
      if (resourceMetadata[i].getElementsByTagName('grade')[0] != undefined &&resourceMetadata[i].getElementsByTagName('grade')[0].hasChildNodes()) {
        if (resourceMetadata[i].getElementsByTagName('grade')[0].getElementsByTagName('title')[0] != undefined &&resourceMetadata[i].getElementsByTagName('grade')[0].getElementsByTagName('title')[0].hasChildNodes()) {
          grade = resourceMetadata[i].getElementsByTagName('grade')[0].getElementsByTagName('title')[0].firstChild.nodeValue;
        } else {
          grade = '';
        }
      } else {
        grade = '';
      }
     //----------//chapter
      if (resourceMetadata[i].getElementsByTagName('chapter')[0] != undefined &&resourceMetadata[i].getElementsByTagName('chapter')[0].hasChildNodes()) {
        if (resourceMetadata[i].getElementsByTagName('chapter')[0].getElementsByTagName('title')[0] != undefined &&resourceMetadata[i].getElementsByTagName('chapter')[0].getElementsByTagName('title')[0].hasChildNodes()) {
          chapter = resourceMetadata[i].getElementsByTagName('chapter')[0].getElementsByTagName('title')[0].firstChild.nodeValue;
        } else {
          chapter = '';
        }
      } else {
        chapter = '';
      }
     //----------//teachingpoint
      if (resourceMetadata[i].getElementsByTagName('teachingpoint')[0] != undefined &&resourceMetadata[i].getElementsByTagName('teachingpoint')[0].hasChildNodes()) {
        if (resourceMetadata[i].getElementsByTagName('teachingpoint')[0].getElementsByTagName('title')[0] != undefined &&resourceMetadata[i].getElementsByTagName('teachingpoint')[0].getElementsByTagName('title')[0].hasChildNodes()) {
          teachingpoint = resourceMetadata[i].getElementsByTagName('teachingpoint')[0].getElementsByTagName('title')[0].firstChild.nodeValue;
        } else {
          teachingpoint = '';
        }
      } else {
        teachingpoint = '';
      }
     //----------//type
      if (resourceMetadata[i].getElementsByTagName('type')[0] != undefined &&resourceMetadata[i].getElementsByTagName('type')[0].hasChildNodes()) {
        type = resourceMetadata[i].getElementsByTagName('type')[0].firstChild.nodeValue;
      } else {
        type = '';
      }
     //----------//title
      if (resourceMetadata[i].getElementsByTagName('title')[0] != undefined &&resourceMetadata[i].getElementsByTagName('title')[0].hasChildNodes()) {
        title = resourceMetadata[i].getElementsByTagName('title')[0].firstChild.nodeValue;
      } else {
        title = '';
      }

      let resourceMetauserConsoleData = [resouseID,subject,grade,chapter,teachingpoint,type,title]
      resourceMetadataMatrix.push(resourceMetauserConsoleData);
      
      
    }
    console.log("resourceMetadataMatrix",resourceMetadataMatrix);
    return resourceMetadataMatrix;
  }
  genarateUserReqiuredData(data: any): any {
    let userConsole = data.getElementsByTagName('userConsole');
    let usersMetadata = data.getElementsByTagName('userMetadata');
    let schoolTerminal = data.getElementsByTagName('schoolTerminal');
    
    let usersMetadataMatrix = new Array();
    let usermetadataMatrixUpdated = new Array();
    let schoolTerminalMatrix = new Array();
    let userConsoleMatrix = new Array();

    for (let i = 0; i < usersMetadata.length; i++) {
      let userID: any;
      let userName: any;
      let userSubjects: any;
      let listOfUser = new Array();
      if (usersMetadata[i].getAttribute('userId')) {
        userID = usersMetadata[i].getAttribute('userId');
        if (usersMetadata[i].getElementsByTagName('fullName')[0] !== undefined &&usersMetadata[i].getElementsByTagName('fullName')[0].hasChildNodes()) {
          userName = usersMetadata[i].getElementsByTagName('fullName')[0].firstChild.nodeValue; // get name of user w.r.t. ID
        } else {
          userName = '';
        }
        if (usersMetadata[i].getElementsByTagName('userSubjects')[0] !== undefined && usersMetadata[i] .getElementsByTagName('userSubjects')[0].hasChildNodes()) {
          userSubjects = usersMetadata[i].getElementsByTagName('userSubjects')[0].firstChild.nodeValue;                          // get userSubjects of user w.r.t. ID
        } else {
          userSubjects = '';
        }
        listOfUser = [userID, userName, userSubjects];
        usersMetadataMatrix.push(listOfUser);                      // array of all users
      }
    }
    for (var i = 0; i < usersMetadataMatrix.length; i++) {
      usersMetadataMatrix.forEach(element => {
        if (usersMetadataMatrix[i][1] === element[1]) {
        
          usermetadataMatrixUpdated.push(usersMetadataMatrix[i]);  //array of same name users
          usersMetadataMatrix.splice(i, 1);                        //delete the same name users from usermetadataMatrix

        }
      });
    }
    for (var i = 0; i < usermetadataMatrixUpdated.length; i++) {
      usermetadataMatrixUpdated[i][1] = usermetadataMatrixUpdated[i][1] + " " + i;
     
      usersMetadataMatrix.push(usermetadataMatrixUpdated[i]);            //adding same name users in usermetadataMatrix with some random charators
    }
    
    for (var i = 0; i < schoolTerminal.length; i++) {
      let schoolId:any;
      let terminalKey:any;
      let terminalType:any;
      let location:any;
      let schoolTerminalData = new Array();

      //----------//schoolId
      if (schoolTerminal[i].getElementsByTagName('schoolId')[0] !== undefined && schoolTerminal[i].getElementsByTagName('schoolId')[0].hasChildNodes()) {
        schoolId = schoolTerminal[i].getElementsByTagName('schoolId')[0].firstChild.nodeValue; // get Id of user
      } else {
        schoolId = '';
      }
     
      //----------//terminalKey
      if (schoolTerminal[i].getElementsByTagName('terminalKey')[0] !== undefined && schoolTerminal[i].getElementsByTagName('terminalKey')[0].hasChildNodes()) {
        terminalKey = schoolTerminal[i].getElementsByTagName('terminalKey')[0].firstChild.nodeValue; // get Id of user
      } else {
        terminalKey = '';
      }
     
      //----------//terminalType
      if (schoolTerminal[i].getElementsByTagName('terminalType')[0] !== undefined && schoolTerminal[i].getElementsByTagName('terminalType')[0].hasChildNodes()) {
        terminalType = schoolTerminal[i].getElementsByTagName('terminalType')[0].firstChild.nodeValue; // get Id of user
      } else {
        terminalType = '';
      } 
      //----------//location
      if (schoolTerminal[i].getElementsByTagName('location')[0] !== undefined && schoolTerminal[i].getElementsByTagName('location')[0].hasChildNodes()) {
        location = schoolTerminal[i].getElementsByTagName('location')[0].firstChild.nodeValue; // get Id of user
      } else {
        location = '';
      }
     schoolTerminalData = [schoolId,terminalKey,terminalType,location];
     
     schoolTerminalMatrix.push(schoolTerminalData);
     
    }
    for (let index = 0; index < userConsole.length; index++) {
      let userId: any;
      let startTime: any;
      let endTime: any;
      let duration: any;
      let selectedDate: any;
      let terminalIP: any;
      let userConsoleResources: any;
        let resourceMetadataIDS: any;
        let resourceMetauserConsoleData = new Array();
      let userName:any;
      let userSubjects:any;
     let terminalLocation: any;
       //----------//user iD
      if (userConsole[index].getElementsByTagName('userId')[0] !== undefined && userConsole[index].getElementsByTagName('userId')[0].hasChildNodes()) {
        userId = userConsole[index].getElementsByTagName('userId')[0].firstChild.nodeValue; // get Id of user
      } else {
        userId = '';
      }
     
      //----------// startTime 
      if (userConsole[index].getElementsByTagName('startTime')[0] !== undefined && userConsole[index].getElementsByTagName('startTime')[0].hasChildNodes()) {
        startTime = userConsole[index].getElementsByTagName('startTime')[0].firstChild.nodeValue; // get Id of user
      } else {
        startTime = '';
      }
      
      //----------// endTime 
      if (userConsole[index].getElementsByTagName('endTime')[0] !== undefined && userConsole[index].getElementsByTagName('endTime')[0].hasChildNodes()) {
        endTime = userConsole[index].getElementsByTagName('endTime')[0].firstChild.nodeValue; // get Id of user
        this.myEndTime = endTime
      } else {
        endTime = '';
      }
      
      //----------// Date 
      if (userConsole[index].getElementsByTagName('selectedDate')[0] !== undefined && userConsole[index].getElementsByTagName('selectedDate')[0].hasChildNodes()) {
        selectedDate = userConsole[index].getElementsByTagName('selectedDate')[0].firstChild.nodeValue; // get Id of user
      } else {
        selectedDate = '';
      }
       //----------// Duration
       if (userConsole[index].getElementsByTagName('duration')[0] !== undefined && userConsole[index].getElementsByTagName('duration')[0].hasChildNodes()) {
          duration = userConsole[index].getElementsByTagName('duration')[0].firstChild.nodeValue;
      } else {
          duration = '0';
      }
       //----------// terminalIP
       if (userConsole[index].getElementsByTagName('terminalIP')[0] !== undefined && userConsole[index].getElementsByTagName('terminalIP')[0].hasChildNodes()) {
        terminalIP = userConsole[index].getElementsByTagName('terminalIP')[0].firstChild.nodeValue;
      } else {
        terminalIP = '0';
      }
      //----------// userConsoleResources
      userConsoleResources = userConsole[index].getElementsByTagName('userConsoleResource');
      for (let i = 0; i < userConsoleResources.length; i++) {
        if (userConsoleResources[i] != undefined && userConsoleResources[i].hasChildNodes()) {
          resourceMetadataIDS = userConsoleResources[i].firstChild.nodeValue;
        } else {
          resourceMetadataIDS = '';
        }
       
        resourceMetauserConsoleData.push(resourceMetadataIDS);
      }
      //----------// userName and userSubjects
      for (let i = 0; i < usersMetadataMatrix.length; i++) {
        if (userId === usersMetadataMatrix[i][0]) {
          userName = usersMetadataMatrix[i][1];
          userSubjects = usersMetadataMatrix[i][2];
        }
      }
       //----------// terminalIP and terminalLocation
      for (let i = 0; i < schoolTerminalMatrix.length; i++) {
        if (terminalIP === schoolTerminalMatrix[i][1]) {
          terminalLocation = schoolTerminalMatrix[i][3];
        }
      }
      let userData = [userId,userName,new Date(startTime),new Date(endTime),terminalIP,resourceMetauserConsoleData,duration,terminalLocation,userSubjects]
     
      userConsoleMatrix.push(userData);
    }
      return {usersMetadata:usersMetadataMatrix,schoolTerminalData:schoolTerminalMatrix,userConsoleData: userConsoleMatrix}
  }
  userWiseChartData(userConsoleData: any){
    let dataTableforChart = new Array();
    if(userConsoleData.length > 0){
      for(let i = 0; i < userConsoleData.length; i++){
        let userData = [userConsoleData[i][1],userConsoleData[i][2],userConsoleData[i][3]];
        dataTableforChart.push(userData);
      }
    }
    return dataTableforChart;
  }
  classRoomWiseChartData(userConsoleData: any){
    let dataTableforChart = new Array();
    for(let i = 0; i < userConsoleData.length; i++){
      let userData = [userConsoleData[i][7],userConsoleData[i][2],userConsoleData[i][3]];
      dataTableforChart.push(userData);
    }
    return dataTableforChart;
  }
  allUserChartData(userConsoleData: any,usersMetadataMatrix:any){
    let dataTableforChart = new Array();
    let inActiveuserName: any;
    let userSubjects: any;
    let myID: any;
    
    let AlluserDetails =new Array();
    let AlluserDetailsForTableChart =new Array();
    
    for (let index = 0; index < userConsoleData.length; index++) {
      AlluserDetails.push(userConsoleData[index]);
      AlluserDetailsForTableChart.push(userConsoleData[index])
    }
    for (let i = 0; i < usersMetadataMatrix.length; i++) {
      myID = usersMetadataMatrix[i][0];
      inActiveuserName = usersMetadataMatrix[i][1];
      userSubjects = usersMetadataMatrix[i][2];
      let myChartRowuserConsoleData = [myID,inActiveuserName,new Date(this.myEndTime),new Date(this.myEndTime),"",[],"0","",userSubjects];
      AlluserDetails.push(myChartRowuserConsoleData);
      let myTableRowuserConsoleData = [myID,inActiveuserName,"","","",[],"0","",userSubjects];
      AlluserDetailsForTableChart.push(myTableRowuserConsoleData);
    }
    for(let i = 0; i < AlluserDetails.length; i++){
      let userData = [AlluserDetails[i][1],AlluserDetails[i][2],AlluserDetails[i][3]];
      dataTableforChart.push(userData);
    }
    return {forChartData:dataTableforChart,fordurationTable:AlluserDetailsForTableChart}
  }
  allRoomsData(userConsoleData: any,schoolTerminalMatrix:any){
    let dataTableforChart = new Array();
    let myChartRowData = new Array();
    let inActiveClassRoom: any;
    let endTime: any;
    let allRoomsDetails = new Array();
    for(let i = 0; i < userConsoleData.length; i++){
      allRoomsDetails.push(userConsoleData[i]);
      let userData = [userConsoleData[i][7],userConsoleData[i][2],userConsoleData[i][3]];
      dataTableforChart.push(userData);
    }
    
    for (let i = 0; i < schoolTerminalMatrix.length; i++) {
      inActiveClassRoom = schoolTerminalMatrix[i][3];
      myChartRowData = ["","",new Date(this.myEndTime),new Date(this.myEndTime),"",[],"0",inActiveClassRoom,""];
      allRoomsDetails.push(myChartRowData);
      let myChartRowuserConsoleData = [inActiveClassRoom,endTime,endTime];
      dataTableforChart.push(myChartRowuserConsoleData);
    }
    for(let i = 0; i < userConsoleData.length; i++){
      let userData = [userConsoleData[i][7],userConsoleData[i][2],userConsoleData[i][3]];
      dataTableforChart.push(userData);
    }
    
    return {forChartData:dataTableforChart,fordurationTable:allRoomsDetails};
  }
  dataForTableView(userConsoleMatrix: any,resourceMetadataMatrix: any) {
    let currentDate: any;
    let resourceMatrixForTableChart = new Array();
    resourceMatrixForTableChart = [];
    for (let i = 0; i <userConsoleMatrix.length; i++) {
      let startTime: any;
      let endTime: any;
      let duration: any;
      let terminalIP: any;
      let subject: any;
      let grade: any;
      let chapter: any;
      let AssestDetail: any;
      let teachingpoint: any;
      let location: any;
      let teacherName: any;
      let teacherSubject: any;
      
      let resourceMetadataIDs: any;
      let resourceArrayForTableChart = new Array();
      let userConsoleDataMatrix = new Array();
      resourceArrayForTableChart = [];
      userConsoleDataMatrix = [];
     //----------------- for subject and Name
      teacherSubject = userConsoleMatrix[i][8];
      teacherName = userConsoleMatrix[i][1];
      //----------------- for start Time  and EndTime 
      if ((userConsoleMatrix[i][2] != undefined && userConsoleMatrix[i][2] != "") && (userConsoleMatrix[i][3] != undefined&&userConsoleMatrix[i][3] != "")) {
        startTime = userConsoleMatrix[i][2].toLocaleTimeString('en-US', { hour12: true });
        endTime = userConsoleMatrix[i][3].toLocaleTimeString('en-US', { hour12: true });
        currentDate = userConsoleMatrix[i][2].getDate() + '/' + userConsoleMatrix[i][2].getMonth() + '/' + userConsoleMatrix[i][2].getFullYear();
      }
      //----------------- for duration
      duration = Math.floor(userConsoleMatrix[i][6]);
      //----------------- for Terminal loaction and terminal IP
      location = userConsoleMatrix[i][7];
      terminalIP = userConsoleMatrix[i][4];
      let roomDetail = location + ' ' + terminalIP;
      resourceMetadataIDs = userConsoleMatrix[i][5];
      if (resourceMetadataIDs.length == 0) {
        subject = undefined;
        grade = undefined;
        chapter = undefined;
        teachingpoint = undefined;
        AssestDetail = undefined;
        resourceArrayForTableChart = [teacherName,teacherSubject,currentDate,startTime,endTime,duration,roomDetail,subject,grade,chapter,teachingpoint,AssestDetail];
        resourceMatrixForTableChart.push(resourceArrayForTableChart);
      }else{
        //resourceMetadataMatrix = [resouseID,subject,grade,chapter,teachingpoint,type]
        for (let k = 0; k < resourceMetadataIDs.length; k++) {
          for (let i = 0; i < resourceMetadataMatrix.length; i++) {
            if (resourceMetadataIDs[k] === resourceMetadataMatrix[i][0]) {
              subject = resourceMetadataMatrix[i][1];
              grade = resourceMetadataMatrix[i][2];
              chapter = resourceMetadataMatrix[i][3];
              teachingpoint = resourceMetadataMatrix[i][4];
              AssestDetail = resourceMetadataMatrix[i][5] + ": " + resourceMetadataMatrix[i][6];
              resourceArrayForTableChart = [teacherName,teacherSubject,currentDate,startTime,endTime,duration,roomDetail,subject,grade,chapter,teachingpoint,AssestDetail];
              resourceMatrixForTableChart.push(resourceArrayForTableChart);
                teacherName = undefined;
                teacherSubject = undefined;
                currentDate = undefined;
                startTime = undefined;
                endTime = undefined;
                duration = undefined;
                roomDetail = undefined;
            }
          }
        }
      }
    }
   
    return resourceMatrixForTableChart;
  }
  dataForDetailedView(userConsoleMatrix: any,resourceMetadataMatrix: any, rowLabel: any) {
    let detailedView_UserDataMatrix = new Array();
         detailedView_UserDataMatrix = [];
    let detailedView_ResourceDataMatrix = new Array();
         detailedView_ResourceDataMatrix = [];
  
      let startTime: any;
      let endTime: any;
      let duration: any;
      let terminalIP: any;
      let subject: any;
      let grade: any;
      let chapter: any;
      let AssestDetail: any;
      let teachingpoint: any;
      let location: any;
      let teacherName: any;
      let teacherSubject: any;
      let currentDate: any;
      let resourceMetadataIDs: any;
      let resourceArrayForTableChart = new Array();
      resourceArrayForTableChart = [];
     //----------------- for subject and Name
      teacherSubject = userConsoleMatrix[rowLabel][8];
      teacherName = userConsoleMatrix[rowLabel][1];
      //----------------- for start Time  and EndTime
      if ((userConsoleMatrix[rowLabel][2] != undefined && userConsoleMatrix[rowLabel][2] != "") && (userConsoleMatrix[rowLabel][3] != undefined&&userConsoleMatrix[rowLabel][3] != "")) {
        startTime = userConsoleMatrix[rowLabel][2].toLocaleTimeString('en-US', { hour12: true });
        endTime = userConsoleMatrix[rowLabel][3].toLocaleTimeString('en-US', { hour12: true });
        currentDate = userConsoleMatrix[rowLabel][2].getDate() + '/' + userConsoleMatrix[rowLabel][2].getMonth() + '/' + userConsoleMatrix[rowLabel][2].getFullYear();
      }
      //----------------- for duration
      duration = Math.floor(userConsoleMatrix[rowLabel][6]);
      //----------------- for Terminal loaction and terminal IP
      location = userConsoleMatrix[rowLabel][7];
      terminalIP = userConsoleMatrix[rowLabel][4];
      let roomDetail = location + ' ' + terminalIP;
      resourceMetadataIDs = userConsoleMatrix[rowLabel][5];

      detailedView_UserDataMatrix =  [teacherName,startTime,teacherSubject,endTime,roomDetail]
      
      if (resourceMetadataIDs.length == 0) {
        subject = undefined;
        grade = undefined;
        chapter = undefined;
        teachingpoint = undefined;
        AssestDetail = undefined;
        resourceArrayForTableChart = [subject,grade,chapter,teachingpoint,AssestDetail];
        detailedView_ResourceDataMatrix.push(resourceArrayForTableChart);
      }else{
        for (let k = 0; k < resourceMetadataIDs.length; k++) {
          for (let i = 0; i < resourceMetadataMatrix.length; i++) {
            if (resourceMetadataIDs[k] === resourceMetadataMatrix[i][0]) {
              subject = resourceMetadataMatrix[i][1];
              grade = resourceMetadataMatrix[i][2];
              chapter = resourceMetadataMatrix[i][3];
              teachingpoint = resourceMetadataMatrix[i][4];
              AssestDetail =resourceMetadataMatrix[i][5] + ": " + resourceMetadataMatrix[i][6];
              
              resourceArrayForTableChart = [subject,grade,chapter,teachingpoint,AssestDetail];
              detailedView_ResourceDataMatrix.push(resourceArrayForTableChart);
            }
          }
        }
      }   
    return {userDetails:detailedView_UserDataMatrix,resourceDetails:detailedView_ResourceDataMatrix};
  }
}

